// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1N215","switchField":"Settings_switchField__1imIc","switchLabel":"Settings_switchLabel__11avb"};